import theme from '../../../../../lib/theme';

const {
  layouts,
  colors,
  scale,
  media,
  font: { families, heights, spacings, ...font },
} = theme;

const blockHeight = 300;

export default () => ({
  container: {
    ...layouts.column,

    alignItems: 'center',
    padding: `0 ${scale.xs}`,

    [media.s.up]: {
      padding: `0 ${scale.s}`,
    },
  },

  entryBlocks: {
    display: `flex`,
    flexWrap: `wrap`,
    gap: '1em',
    width: `100%`,

    [media.m.down]: {
      flexDirection: `column`,
    },
  },

  entryCard: {
    flex: `0 0 calc(100% / 3 - 1em)`,
    width: `calc(100% / 3 - 1em)`,
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    backgroundSize: `cover`,
    backgroundPosition: `center`,
    minHeight: blockHeight,

    [media.l.down]: {
			flex: `0 0 calc(50% - 1em)`,
			width: `calc(50% - 1em)`,	
    },

    [media.m.down]: {
      flex: `0 0 calc(100% - 1em)`,
      width: `calc(100% - 1em)`,
    },

    '&:after': {
      background: `linear-gradient( 0deg,rgba(0,0,0,0.9),rgba(0,0,0,0))`,
      position: `absolute`,
      content: `""`,
      bottom: `0`,
      height: `50%`,
      left: `0`,
      width: `100%`,
    },
  },
  entryContentContainer: {
    width: `100%`,
    display: `flex`,
    flexDirection: `column`,
    zIndex: 1,
    padding: `0 1rem 1rem`,
  },
  entryTitle: {
    color: colors.white,
    fontWeight: font.bold,
    fontSize: scale.s,
  },
  entryMetaContainer: {
    display: `flex`,
    width: `100%`,
    justifyContent: `space-between`,
    color: colors.white,
    alignItems: `flex-start`,
    gap: scale.xxs,
    flexDirection: `column`,
  },
  entryMeta: {
    display: `flex`,
    justifyContent: `flex-start`,
    alignItems: `center`,
    color: colors.white,
  },
  entryCategory: {
    backgroundColor: colors.travel360.secondary,
    color: colors.black,
    padding: `1px 1px 1px 7px`,
    fontSize: scale.xs,
    fontWeight: font.bold,
    textTransform: `uppercase`,
    borderRadius: `4px`,
    display: 'flex',
    alignItems: 'center',

    ':hover': {
      color: colors.black,
    },
  },
  entryLink: {
    color: colors.white,

    '&:hover': {
      color: colors.white,
    },
  },
  entryDescription: {
    order: 1,
  },
  entryVideo: {
    order: 1,
    padding: `${scale.s} 0 0 0`,

    [media.m.down]: {
      padding: `0 0 ${scale.s} 0`,
      order: 0,
    },
  },
  alert: {
    fontSize: '1.1rem',
    width: '100%',
    margin: `0`,
  },	
});
